import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export interface PaginationMeta {
    currentPage: number;
    totalPages: number;
    totalCount: number;
    limit: number;
}

interface TablePaginationProps {
    pagination: PaginationMeta | null;
    onPageChange: (page: number) => void;
    itemLabel?: string;
    variant?: "dark" | "light";
}

const TablePagination = ({
    pagination,
    onPageChange,
    itemLabel = "items",
    variant = "dark",
}: TablePaginationProps) => {
    if (!pagination || pagination.totalPages <= 1) {
        return null;
    }

    const { currentPage, totalPages, totalCount, limit } = pagination;
    const start = (currentPage - 1) * limit + 1;
    const end = Math.min(currentPage * limit, totalCount);
    const light = variant === "light";

    return (
        <div
            className={`flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 px-4 sm:px-6 py-4 sm:py-5 border-t ${
                light ? "border-[#E8E8E4]" : "border-[#1f2221]"
            }`}
        >
            <p
                className={`text-sm text-center sm:text-left ${
                    light ? "text-[#8A8A85]" : "text-[#8b8f8d]"
                }`}
            >
                Showing {start}-{end} of {totalCount} {itemLabel}
            </p>
            <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap justify-center">
                <button
                    type="button"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                    className={`flex items-center gap-1 px-3 sm:px-4 py-2 rounded-xl border disabled:opacity-40 transition text-sm ${
                        light
                            ? "border-[#DDDDD8] bg-white text-[#4A4A48] hover:bg-[#F8F8F6]"
                            : "border-[#2a2d2c] bg-[#080808] hover:bg-[#151716]"
                    }`}
                >
                    <FiChevronLeft />
                    <span className="hidden sm:inline">Previous</span>
                    <span className="sm:hidden">Prev</span>
                </button>
                <span
                    className={`px-2 sm:px-3 text-sm whitespace-nowrap ${
                        light ? "text-[#4A4A48]" : "text-[#b7bab8]"
                    }`}
                >
                    {currentPage} / {totalPages}
                </span>
                <button
                    type="button"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                    className={`flex items-center gap-1 px-3 sm:px-4 py-2 rounded-xl border disabled:opacity-40 transition text-sm ${
                        light
                            ? "border-[#DDDDD8] bg-white text-[#4A4A48] hover:bg-[#F8F8F6]"
                            : "border-[#2a2d2c] bg-[#080808] hover:bg-[#151716]"
                    }`}
                >
                    Next
                    <FiChevronRight />
                </button>
            </div>
        </div>
    );
};

export default TablePagination;
